import gql from 'graphql-tag';

export const ADDITIONAL_ACCOUNT_RELATION_FRAGMENT = gql`
  fragment AdditionalAccountRelationViewModel on AdditionalAccountRelationViewModel {
    id
    role
    accountId
    createdAt
    accountName
    accountType
    locationName
    userProfileId
  }
`;
